/**
 * Feature flag for the whole risk assessment reports area (nav entry, routes,
 * node detail tab). Baked in at build time by CRA: true on testing and in
 * local dev (.env.testing / .env.local), false on staging and production.
 * Kept as a module so tests can mock it via jest.mock.
 */
export const isRiskReportsEnabled = (): boolean =>
    process.env.REACT_APP_ENABLE_RISK_REPORTS === 'true';
